var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ActivityDetail"},[_c('DetailComp',{ref:"detail-comp",attrs:{"activity-id":_vm.activityId,"tour-id":_vm.tourId,"product-id":_vm.productId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }